import axios from 'axios';
import type { XLesson } from '@/models/xlesson';
import type { Tag } from '@/models/tag';
import type { XSubProcess } from '@/models/xsubprocess';

class XLessonWebservice {
    public load(xSubProcessId: number, exclude_lesson_id: number | null = null) {
        return axios.get<XLesson[]>('/xlessons', {
            params: {
                xSubProcessId,
                exclude_lesson_id,
            },
        });
    }

    public loadLessonsByApproved(approved: boolean) {
        return axios.get<XLesson[]>('/xlessons/loadLessonsByApproved', {
            params: {
                approved,
            },
        });
    }

    public getById(xLessonId: number) {
        return axios.get<XLesson>('/xlessons/getById', {
            params: {
                xLessonId,
            },
        });
    }

    public count() {
        return axios.get<number>('/xlessons/count');
    }

    public countPersonal() {
        return axios.get<number>('/xlessons/countPersonal');
    }

    // tslint:disable-next-line:max-line-length
    public store(
        xLesson: XLesson,
        xSubProcessId: number,
        mandatory: boolean = false,
        tags: Tag[],
        userId: number | null = null,
        projectId = 0,
        parentLesson: XLesson | null = null
    ) {
        const parentId = parentLesson ? parentLesson.id : null;
        return axios.post('/xlessons/store', {
            insight: xLesson.insight,
            more_info: xLesson.more_info,
            xSubProcessId,
            mandatory,
            tags: tags.map((tag) => tag.id),
            userId,
            projectId,
            parentId,
        });
    }

    public storeApproved(xLesson: XLesson, approved: boolean) {
        return axios.post('/xlessons/storeApproved', {
            xLessonId: xLesson.id,
            approved,
        });
    }

    public update(
        xLesson: XLesson,
        xSubProcess: XSubProcess,
        mandatory: boolean = false,
        tags: Tag[],
        projectId = 0,
        parentLesson: XLesson | null = null
    ) {
        const parentId = parentLesson ? parentLesson.id : null;
        return axios.post('/xlessons/update', {
            id: xLesson.id,
            insight: xLesson.insight,
            more_info: xLesson.more_info,
            xSubProcessId: xSubProcess.id,
            mandatory,
            tags: tags.map((tag) => tag.id),
            projectId,
            parentId,
        });
    }

    // noinspection JSUnusedGlobalSymbols
    public updateOrder(lesson: XLesson, direction: string = 'up') {
        return axios.post('/xlessons/update/order', {
            id: lesson.id,
            direction,
        });
    }
    public remove(xLesson: XLesson) {
        return axios.post('/xlessons/remove', {
            id: xLesson.id,
        });
    }
}

export const xLessonWebservice = new XLessonWebservice();
